import PluginOutlet from "discourse/components/plugin-outlet";
import lazyHash from "discourse/helpers/lazy-hash";
import CirclesFormProfileFields from "../../../components/circles/form-profile-fields";

const CircleManageProfile = <template>
  <PluginOutlet
    @name="circles-manage-profile"
    @connectorTagName="div"
    @outletArgs={{lazyHash model=@model}}
  >
    <CirclesFormProfileFields
      @model={{@model}}
      @onBeforeSave={{@controller.onBeforeSave}}
      @onAfterSave={{@controller.onAfterSave}}
      @hideCancelBtn={{true}}
    />
  </PluginOutlet>
</template>;

export default CircleManageProfile;
